import {
  Box,
  Typography,
  Chip,
  IconButton,
  Alert,
  Fade,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import BackClickBottomSheet from '../../Permit/ui/BackClickBottomSheet';
import { Combo, MultiChipSelect } from '../../../Components/MUIs';
import InputText from '../../WorkInfo/ui/InputText';
import { useState, useMemo } from 'react';
import dayjs from 'dayjs';
import { StaticDatePicker } from '@mui/x-date-pickers';
import {
  AttachFile as AttachFileIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import Global from '../../../Services/Common/Global';
import PerButton from '../../Permit/ui/PerButton';
import { M_NOT_BASIC_02_Schema } from './M_NOT_BASIC_02_Schema';

const gubunComboData = [
  { name: '전체', value: '0' },
  { name: '사업장', value: '1' },
  { name: '부서', value: '2' },
];

const WHOLE_NOTICE = '전체 사업장·부서에 공지가 적용됩니다. ';

/** HEAD_MANAGER: 구분「전체」= 소속 사업장 단위 전체(본인 cust)로 저장됨 */
const WHOLE_NOTICE_HEAD_MANAGER =
  '소속 사업장(본 사업장) 전체에 공지가 적용됩니다. ';

const defaultTargetProps = {
  isTargetSelectRole: false,
  targetLoading: false,
  coList: [],
  selectedCo: '',
  onCoChange: () => {},
  gubunDtlItems: [],
  custListForDept: [],
  selectedCustForDept: '',
  onCustForDeptChange: () => {},
  onGubunChange: () => {},
};

export default function M_NOT_BASIC_02(props) {
  const tp = { ...defaultTargetProps, ...props };
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const bottomSheetState = useSelector((state) => state.bottomSheet);

  const [pickerVisible, setPickerVisible] = useState(null);

  const workInfoFields = [
    { name: 'title', maxLength: 100 },
    { name: 'comment', maxLength: 1000 },
  ];

  const handleEndDateSelect = (date) => {
    const formatted = dayjs(date).format('YYYY-MM-DD');
    props.setNoticeInputs({
      ...props.noticeInputs,
      endDate: formatted,
    });
  };

  const gubun = String(props.noticeInputs.gubun || '0');
  const isHeadManager = userInfo?.authCd === 'HEAD_MANAGER';
  const gubunItems = useMemo(() => {
    if (isHeadManager) {
      return gubunComboData.filter((i) => i.value !== '1');
    }
    return gubunComboData;
  }, [isHeadManager]);

  const showDeptSite =
    gubun === '2' && ['ADMIN', 'BUSINESS_OWNER'].includes(userInfo?.authCd);

  const coListForCombo = tp.coList || [];
  const multiItems = tp.gubunDtlItems || [];

  const isMultiDisabled =
    gubun === '0' ||
    (gubun === '2' && showDeptSite && !tp.selectedCustForDept) ||
    (tp.targetLoading && (gubun === '1' || gubun === '2'));

  const onSave = () => {
    if (tp.isTargetSelectRole) {
      if (userInfo?.authCd === 'ADMIN' && !tp.selectedCo) {
        dispatch(
          showSnackbar({ message: '회사를 선택해주세요', type: 'warning' })
        );
        return;
      }
      if (gubun !== '0') {
        const dtl = props.noticeInputs.gubunDtl;
        if (gubun === '2' && showDeptSite && !tp.selectedCustForDept) {
          dispatch(
            showSnackbar({
              message: '사업장을 먼저 선택해주세요',
              type: 'warning',
            })
          );
          return;
        }
        if (!Array.isArray(dtl) || dtl.length === 0) {
          dispatch(
            showSnackbar({ message: '대상을 선택해주세요', type: 'warning' })
          );
          return;
        }
      }
    }
    props.SaveLogic1();
  };

  const wholeHintText = isHeadManager
    ? WHOLE_NOTICE_HEAD_MANAGER
    : WHOLE_NOTICE;
  const multiLabel =
    gubun === '0'
      ? wholeHintText
      : gubun === '1'
        ? '사업장을 선택하세요'
        : '부서를 선택하세요';

  return (
    <Box sx={{ px: 2 }}>
      <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
        공지사항
        <br />
        작성을 시작할게요.
      </p>
      <p style={{ fontSize: '16px', color: '#939393' }}>
        아래 사항들을 작성해주세요.
      </p>

      <Box sx={{ my: 2 }}>
        {tp.isTargetSelectRole && (
          <Box
            sx={{
              mb: 2,
              p: 2,
              backgroundColor: 'transparent',
            }}
          >
            <Typography
              sx={{
                fontWeight: 'bold',
                fontSize: '16px',
                mb: 1.5,
                color: '#2c2c2c',
              }}
            >
              대상 선택 <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>

            {userInfo?.authCd === 'ADMIN' && coListForCombo.length > 0 && (
              <Box sx={{ marginBottom: '16px' }}>
                <label
                  style={{
                    fontWeight: 'bold',
                    fontSize: '16px',
                    color: '#2c2c2cff',
                  }}
                >
                  회사
                </label>
                <Combo
                  wrapSx={{ width: '100%', mt: 1 }}
                  items={coListForCombo}
                  value={tp.selectedCo || ''}
                  onChange={(e) => tp.onCoChange(e)}
                  name="회사"
                />
              </Box>
            )}

            <Box sx={{ marginBottom: '16px' }}>
              <label
                style={{
                  fontWeight: 'bold',
                  fontSize: '16px',
                  color: '#2c2c2cff',
                }}
              >
                구분
              </label>
              <Combo
                wrapSx={{ width: '100%', mt: 1 }}
                items={gubunItems}
                value={gubun}
                onChange={async (e) => {
                  if (userInfo?.authCd === 'ADMIN') {
                    await tp.onGubunChange(e);
                    return;
                  }
                  props.setNoticeInputs({
                    ...props.noticeInputs,
                    gubun: e,
                    gubunDtl: [],
                    gubunDtlNm: [],
                  });
                  await tp.onGubunChange(e);
                }}
                name="구분"
              />
            </Box>

            {gubun === '0' ? (
              <Box
                sx={{
                  py: 1.5,
                  px: 1,
                  borderRadius: 1,
                  backgroundColor: '#e3f2fd',
                  border: '2px solid #2196f3',
                }}
              >
                <Typography
                  sx={{ color: '#1565c0', fontWeight: 600, fontSize: '15px' }}
                >
                  {wholeHintText}
                </Typography>
              </Box>
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  gap: 2,
                  alignItems: { xs: 'stretch', sm: 'flex-start' },
                }}
              >
                {showDeptSite && (
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <label
                      style={{
                        fontWeight: 'bold',
                        fontSize: '16px',
                        color: '#2c2c2cff',
                      }}
                    >
                      사업장
                    </label>
                    <Combo
                      wrapSx={{ width: '100%', mt: 1 }}
                      items={tp.custListForDept}
                      value={tp.selectedCustForDept || ''}
                      onChange={(e) => tp.onCustForDeptChange(e)}
                      name="사업장"
                    />
                  </Box>
                )}

                <Box sx={{ flex: 2, minWidth: 0 }}>
                  <label
                    style={{
                      fontWeight: 'bold',
                      fontSize: '16px',
                      color: '#2c2c2cff',
                      display: 'block',
                      marginBottom: '8px',
                    }}
                  >
                    구분 상세
                  </label>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                      backgroundColor: gubun === '0' && '#f5f5f5',
                      color: gubun === '0' && '#555',
                      pointerEvents: gubun === '0' ? 'none' : 'auto',
                    }}
                  >
                    <MultiChipSelect
                      items={multiItems}
                      value={props.noticeInputs.gubunDtl}
                      onChange={(e) => {
                        const selectedValues = e.target.value;
                        const selectedNames = (multiItems || [])
                          .filter((item) => selectedValues.includes(item.value))
                          .map((item) => item.name);
                        props.setNoticeInputs({
                          ...props.noticeInputs,
                          gubunDtl: selectedValues,
                          gubunDtlNm: selectedNames,
                        });
                      }}
                      disabled={isMultiDisabled}
                      label={multiLabel}
                    />
                  </Box>
                </Box>
              </Box>
            )}

            {gubun !== '0' &&
              (!props.noticeInputs.gubunDtl?.length ||
                (gubun === '2' && showDeptSite && !tp.selectedCustForDept)) && (
                <Alert severity="warning" sx={{ mt: 1.5 }}>
                  {gubun === '2' && showDeptSite && !tp.selectedCustForDept
                    ? '사업장을 선택한 뒤 부서를 선택해주세요'
                    : '대상을 선택해주세요'}
                </Alert>
              )}
          </Box>
        )}

        {userInfo?.authCd === 'ADMIN' && (
          <Fade in timeout={300}>
            <Box
              sx={{
                mb: 2,
                p: 2,
                backgroundColor: 'transparent',
              }}
            >
              <Stack spacing={1.5}>
                <label
                  style={{
                    fontWeight: 'bold',
                    fontSize: '16px',
                    color: '#2c2c2c',
                  }}
                >
                  공지 유형
                  <span style={{ color: '#d32f2f' }}> *</span>
                </label>
                <ToggleButtonGroup
                  value={props.noticeInputs.noticeYn || 'N'}
                  exclusive
                  onChange={(e, newValue) => {
                    const v = newValue == null ? 'N' : newValue;
                    props.setNoticeInputs({
                      ...props.noticeInputs,
                      noticeYn: v,
                    });
                  }}
                  aria-label="공지 유형"
                  sx={{
                    width: '100%',
                    display: 'flex',
                    flexWrap: { xs: 'wrap', sm: 'nowrap' },
                    gap: 1,
                    '& .MuiToggleButtonGroup-grouped': {
                      flex: 1,
                      minWidth: 0,
                      minHeight: 48,
                    },
                  }}
                >
                  <ToggleButton
                    value="N"
                    sx={{ textTransform: 'none', fontWeight: 600 }}
                  >
                    기본 공지
                  </ToggleButton>
                  <ToggleButton
                    value="Y"
                    sx={{ textTransform: 'none', fontWeight: 600 }}
                  >
                    중요 공지
                  </ToggleButton>
                </ToggleButtonGroup>
              </Stack>
            </Box>
          </Fade>
        )}

        <div>
          <p
            style={{
              fontWeight: 'bold',
              fontSize: '16px',
              marginBottom: '8px',
            }}
          >
            공지 종료일
          </p>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
            <button
              onClick={() =>
                setPickerVisible((prev) =>
                  prev === 'endDate' ? null : 'endDate'
                )
              }
              style={{
                fontSize: '16px',
                fontWeight: 'bold',
                border: 'none',
                padding: '8px 10px',
                borderRadius: '5px',
                color: pickerVisible === 'endDate' ? '#007AFF' : '#333',
              }}
            >
              {props.noticeInputs.endDate || '날짜 선택'}
            </button>
          </Box>

          {pickerVisible === 'endDate' && (
            <StaticDatePicker
              value={dayjs(props.noticeInputs.endDate)}
              minDate={dayjs()}
              onChange={handleEndDateSelect}
              slotProps={{
                toolbar: { hidden: true },
                actionBar: { actions: [] },
              }}
            />
          )}
        </div>

        <Box>
          {workInfoFields.map((field) => (
            <InputText
              key={field.name}
              name={field.name}
              schema={M_NOT_BASIC_02_Schema}
              value={props.noticeInputs[field.name] || ''}
              onChange={(e) =>
                props.setNoticeInputs({
                  ...props.noticeInputs,
                  [field.name]: e.target.value,
                })
              }
              maxLength={field.maxLength}
            />
          ))}
        </Box>

        <Box sx={{ marginBottom: '16px' }}>
          <label
            style={{
              fontWeight: 'bold',
              fontSize: '16px',
              color: '#2c2c2cff',
              marginBottom: '8px',
              display: 'block',
            }}
          >
            첨부 자료
          </label>
          <Box
            sx={{
              border: '2px dashed #ccc',
              borderRadius: '8px',
              p: 2,
              textAlign: 'center',
              backgroundColor: '#fafafa',
              position: 'relative',
            }}
          >
            <input
              type="file"
              multiple
              id="file-upload"
              style={{ display: 'none' }}
              onChange={props.FileChange}
            />
            <label htmlFor="file-upload">
              <Box
                sx={{
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                <AttachFileIcon sx={{ fontSize: 32, color: '#666' }} />
                <Typography sx={{ fontSize: '14px', color: '#666' }}>
                  파일을 선택하세요
                </Typography>
                <Typography sx={{ fontSize: '12px', color: '#999' }}>
                  여러 파일을 동시에 업로드할 수 있습니다
                </Typography>
              </Box>
            </label>
          </Box>

          {props.previewList?.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#666',
                  mb: 1,
                }}
              >
                업로드된 파일 (
                {props.previewList.filter((f) => !f.deleted).length}개)
              </Typography>

              {props.previewList.some(
                (f) =>
                  !f.deleted &&
                  !/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(f.fileName || '')
              ) && (
                <Box sx={{ mb: 2 }}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: 1,
                    }}
                  >
                    {props.previewList
                      .filter(
                        (f) =>
                          !f.deleted &&
                          !/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(
                            f.fileName || ''
                          )
                      )
                      .map((item, index) => (
                        <Chip
                          key={index}
                          icon={<AttachFileIcon />}
                          label={item.fileName}
                          onDelete={() => props.DeletePreview(item)}
                          color="primary"
                          variant="outlined"
                          sx={{
                            fontSize: '13px',
                            '& .MuiChip-deleteIcon': {
                              fontSize: '18px',
                            },
                          }}
                        />
                      ))}
                  </Box>
                </Box>
              )}

              {props.previewList.some(
                (f) =>
                  !f.deleted &&
                  /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(f.fileName || '')
              ) && (
                <Box>
                  <Typography
                    sx={{ fontSize: '13px', fontWeight: '600', mb: 1 }}
                  >
                    이미지 미리보기
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: 1,
                    }}
                  >
                    {props.previewList
                      .filter(
                        (f) =>
                          !f.deleted &&
                          /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(
                            f.fileName || ''
                          )
                      )
                      .map((item, index) => (
                        <Box
                          key={index}
                          sx={{
                            position: 'relative',
                            width: '80px',
                            height: '80px',
                            border: '1px solid #DFD9D9',
                            borderRadius: '8px',
                            overflow: 'hidden',
                          }}
                        >
                          <img
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                            src={
                              item.filePath
                                ? `${Global.file.useUrl}files/${item.filePath}`
                                : item.preview
                            }
                            alt={item.fileName}
                          />
                          <IconButton
                            sx={{
                              position: 'absolute',
                              top: 0,
                              right: 0,
                              padding: '4px',
                              backgroundColor: 'rgba(255, 255, 255, 0.8)',
                              '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                              },
                            }}
                            size="small"
                            onClick={() => props.DeletePreview(item)}
                          >
                            <DeleteIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Box>
                      ))}
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </Box>
      </Box>

      <PerButton
        saveText={'저장'}
        onCancel={() =>
          dispatch(
            BottomSheetActions.SetBottomSheetState({
              bottom: true,
              type: 'backClickWor',
            })
          )
        }
        onClick={onSave}
      />

      {bottomSheetState.bottom && bottomSheetState.type === 'backClickWor' && (
        <BackClickBottomSheet open={true} route={'/M_Notice'} />
      )}
    </Box>
  );
}
